import handleMultiSelectChange from './handleMultiSelectChange';

/**
 * Returns a callback that triggers a change for multiselect
 * if the select component is active (open).
 * @param {Element} select
 * @returns {Function}
 */
const handleMultiSelectClose = (select) => (e) => {
    if ($(select).attr('data-active') === 'true') {
        handleMultiSelectChange(select)(e);
    }
};

export default handleMultiSelectClose;



// WEBPACK FOOTER //
// ./src/scripts/components/select/handleMultiSelectClose.js